import React, { Component } from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import ProfileBanner from 'components/ProfileBanner';
import Footer from 'components/MiniFooter';
import Session from 'components/Session';
import PropTypes from 'prop-types';
import { logPageView, initGA } from 'utils/analytics';
import { withRouter } from 'react-router';

import CoachRegistrationModal from 'components/CoachRegistration';
import styles from './Coach-registration.scss';// to import local scss fle

class CoachRegister extends Component {

  static propTypes = {
    attributes: PropTypes.shape.isRequired,
    history: PropTypes.shape.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      value: 'asdad',
    };
  }

  componentWillMount() {
    const { attributes, history } = this.props;
    if (attributes.size > 0) {
      const zoneinfo = attributes.get('zoneinfo');
      if (zoneinfo !== 'COACH') {
        history.goBack();
      }
    }
  }
  componentDidMount() {
    initGA();
    logPageView(this.props.match.path); // eslint-disable-line
  }

  componentWillReceiveProps(nextProps) {
    const { attributes, history } = nextProps;
    if (attributes.size > 0) {
      const zoneinfo = attributes.get('zoneinfo');
      if (zoneinfo !== 'COACH') {
        history.goBack();
      }
    }
  }

  render() {
    return (
      <div className={cn('row', styles.container)}>
        <ProfileBanner {...this.props} />
        <CoachRegistrationModal {...this.props} usedFor="register" />
        <Footer />
      </div>
    );
  }
}


export default withRouter(Session(CoachRegister));



// WEBPACK FOOTER //
// ./src/containers/Coach-register/Coach-registration.js